import * as tslib_1 from "tslib";
import { Location } from '@angular/common';
import { Sync } from './services/sync';
var SyncSetupComponent = /** @class */ (function () {
    function SyncSetupComponent(sync, location) {
        this.sync = sync;
        this.location = location;
        this.dropboxSetup = false;
    }
    SyncSetupComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(location.hash.length > 0)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.sync.completeDropboxSetup()];
                    case 1:
                        _b.sent();
                        this.location.go("");
                        _b.label = 2;
                    case 2:
                        _a = this;
                        return [4 /*yield*/, this.sync.hasDropboxSetup()];
                    case 3:
                        _a.dropboxSetup = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    SyncSetupComponent.prototype.setupDropbox = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sync.requestNewDropbox()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(SyncSetupComponent.prototype, "dropboxMessage", {
        get: function () {
            return this.dropboxSetup
                ? 'Dropbox is already setup!'
                : 'Click the button on the right to setup dropbox';
        },
        enumerable: true,
        configurable: true
    });
    return SyncSetupComponent;
}());
export { SyncSetupComponent };
